import { gql } from './gql'

/**
 * Turns the session's cart into an order.
 *
 * It has to run **before** the cart is emptied — the order is built from the
 * cart, so emptying first produces an order with nothing in it. The session's
 * stored checkout selections ride onto the order automatically, which is why
 * nothing about the delivery date or payment method is passed here.
 *
 * Only the identity is selected. What the confirmation screen shows beyond
 * that is already on hand from the checkout it just completed, and the order
 * detail re-reads the order in full when it is opened.
 *
 * `sequence` and `externalRefNumber` matter as much as `id`: `id` is a Mongo
 * ObjectId, which routes correctly and is unreadable as an order number.
 */
export const CREATE_ORDER = gql`
  mutation CreateOrder($storefrontName: String!, $sessionUid: ID!) {
    createOrder(storefrontName: $storefrontName, sessionUid: $sessionUid) {
      id
      sequence
      externalRefNumber
      status
      total
    }
  }
`
